// this file added by Bearer Web Developer
import React, { useContext } from "react";
interface IMenuDrawerContext {
    setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>
    swipable: () => void
    openDrawer: boolean
    swipe: boolean
    toggleMenuDrawer: (open: boolean) => (event: React.KeyboardEvent<Element> | React.MouseEvent<Element, MouseEvent>) => void
}
export const MenuDrawerContext = React.createContext<IMenuDrawerContext>({
    setOpenDrawer: () => { },
    swipable: () => { },
    openDrawer: false,
    swipe: false,
    toggleMenuDrawer: () => () => { },
});
export const useMenuDrawer = () => useContext(MenuDrawerContext);